export default {
    'table.columnsSetting': 'Columns setting',
    'table.fixedLeft':'Fixed on the left',
    'table.fixedRight':'Fixed on the right',
    'table.unpan': 'Unpan',
    'table.export': 'Export',
    'table.operation': 'Operation'

  };
  